import { render } from "./TimeCounter.vue?vue&type=template&id=5ed097cf"
import script from "./TimeCounter.vue?vue&type=script&lang=js"
export * from "./TimeCounter.vue?vue&type=script&lang=js"

import "./TimeCounter.vue?vue&type=style&index=0&id=5ed097cf&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__